import React, { useState } from "react";

function SupportHelp() {
  const [tickets, setTickets] = useState([
    { id: 1, subject: "Unable to access payroll", status: "Open" },
    { id: 2, subject: "System logout issue", status: "Resolved" },
    { id: 3, subject: "Request for leave approval", status: "Pending" },
  ]);
  const [newTicket, setNewTicket] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newTicket.trim() === "") return;
    const ticket = {
      id: tickets.length + 1,
      subject: newTicket,
      status: "Open",
    };
    setTickets([ticket, ...tickets]);
    setNewTicket("");
  };

  const badgeClass = (status) => {
    if (status === "Resolved") return "emp-soft-badge success";
    if (status === "Pending") return "emp-soft-badge warning";
    return "emp-soft-badge info";
  };

  return (
    <div>
      <h2 className="emp-page-title">Support Desk</h2>
      <p className="emp-page-subtitle">Create support requests and track ticket status.</p>

      <section className="emp-panel mb-3">
        <div className="emp-panel-header">
          <h5 className="mb-1">Submit New Ticket</h5>
        </div>
        <div className="emp-panel-body">
          <form onSubmit={handleSubmit} className="d-flex gap-2">
            <input
              type="text"
              placeholder="Describe your issue..."
              value={newTicket}
              onChange={(e) => setNewTicket(e.target.value)}
              className="form-control"
            />
            <button type="submit" className="btn btn-primary">
              Submit
            </button>
          </form>
        </div>
      </section>

      <section className="emp-panel">
        <div className="emp-panel-header">
          <h5 className="mb-1">Recent Tickets</h5>
        </div>
        <div className="emp-panel-body d-flex flex-column gap-2">
          {tickets.map((ticket) => (
            <div key={ticket.id} className="p-3 rounded-3 border d-flex justify-content-between align-items-center">
              <div>
                <b>#{ticket.id}</b> {ticket.subject}
              </div>
              <span className={badgeClass(ticket.status)}>{ticket.status}</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default SupportHelp;
